// 3rd
// internal
// owned
import Logger from '../logger.js'
// module vars
/**
 * A Simple Implementation of the Logger interface that logs to the console.
 */
export default class ConsoleLogger extends Logger {
  /**
   * Creates a ConsoleLogger instance.
   * @constructor
   * @param {string} name - The logger name.
   * @param {*} nativeLogger - The native console object to use for logging.
   * @param {number} level - The initial log level.
   */
  constructor (name, nativeLogger, level) {
    super(name, nativeLogger, level)
    /**
     * @type {{error:function, warn:function, debug:function, log:function, info:function, trace:function}}
     */
    this.console = nativeLogger
  }

  /**
   * For ConsoleLogger, Nothing to do
   * @param {number} level
   * @override
   * @protectd
   */
  _setLevel (level) {
    // do nothing
  }

  /**
   * Logs a fatal error message with timestamp and logger name.
   * Only outputs if fatal logging is enabled for this logger instance.
   * @param {...any} args
   */
  _fatal (...args) {
    this.console.error(new Date().toISOString(), this.name, '[Fatal]', ...args)
  }

  /**
   * Logs an error message to the console with timestamp and logger name.
   * Only logs if error logging is enabled for this logger instance.
   * @param {...any} args
   */
  _error (...args) {
    this.console.error(new Date().toISOString(), this.name, '[Error]', ...args)
  }

  /**
   * Logs a warning message to the console if warn logging is enabled.
   * @param {...any} args
   */
  _warn (...args) {
    this.console.warn(new Date().toISOString(), this.name, '[Warn]', ...args)
  }

  /**
   * Logs debug messages to console if debug mode is enabled.
   * @param {...any} args
   */
  _debug (...args) {
    this.console.debug(new Date().toISOString(), this.name, '[Debug]', ...args)
  }

  /**
   * Logs an info message to the console with timestamp and logger name.
   * @param {...any} args
   */
  _info (...args) {
    this.console.log(new Date().toISOString(), this.name, '[Info]', ...args)
  }

  /**
   * Logs a trace message with timestamp and logger name if trace logging is enabled.
   * @param {...any} args
   */
  _trace (...args) {
    this.console.log(new Date().toISOString(), this.name, '[Trace]', ...args)
  }
}
